import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { delay, take, tap, timeout } from 'rxjs/operators';
import { Comprovante } from '../_classes/comprovante-ponto';
import { Retorno } from '../_classes/retorno';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root',
})
export class PontoService {
  private headers: HttpHeaders = new HttpHeaders();
  private urlBase = 'serv';

  private delay = 0;
  private timeout = 15000;

  constructor(private env: EnvService, private http: HttpClient) {
    this.headers.append('Content-Type', 'application/json');
    this.timeout = env.timeoutGenerico;
  }

  public getApiUrl(): string {
    return `${this.env.apiUrl}`;
  }

  public log(msg: string, obj: any, erro: boolean = false) {
    if (this.env.enableDebug) {
      erro ? console.error(msg, obj) : console.log(msg, obj);
    }
  }

  getFrqMarcacao(
    servidor: string,
    mes: number,
    ano: number
  ): Observable<Retorno> {
    let endpoint: string =
      this.urlBase +
      '/frequencia/listar-mes/' +
      servidor +
      '/' +
      mes +
      '/' +
      ano;
    let restoUrl: string = endpoint;

    this.log(
      this.constructor.name + '.' + Function.prototype.name + '()',
      this.getApiUrl() + '/' + restoUrl
    );

    return this.http
      .get(this.getApiUrl() + '/' + restoUrl, {
        headers: this.headers,
      })
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  getPrimeiraDataDeFrequencia(idServidor: string): Observable<Retorno> {
    let endpoint: string =
      this.urlBase + '/frequencia/ano-mes/min/' + idServidor;
    let restoUrl: string = endpoint;

    this.log(
      this.constructor.name + '.' + Function.prototype.name + '()',
      this.getApiUrl() + '/' + restoUrl
    );

    return this.http
      .get(this.getApiUrl() + '/' + restoUrl, {
        headers: this.headers,
      })
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  getComprovantePonto(id: number) {
    let endpoint: string = this.urlBase + '/comprovante-ponto/' + id;
    let restoUrl: string = endpoint;

    this.log(
      'teste ABC' +
        this.constructor.name +
        '.' +
        Function.prototype.name +
        '()',
      this.getApiUrl() + '/' + restoUrl
    );

    return this.http
      .get<Comprovante>(this.getApiUrl() + '/' + restoUrl, {
        headers: this.headers,
      })
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  getPontoSemExportarListar(): Observable<Retorno> {
    let endpoint: string = this.urlBase + '/sem-exportar/listar';
    let restoUrl: string = endpoint;

    this.log(
      this.constructor.name + '.' + Function.prototype.name + '()',
      this.getApiUrl() + '/' + restoUrl
    );

    return this.http
      .get(this.getApiUrl() + '/' + restoUrl, {
        headers: this.headers,
      })
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  getPontoSemExportarTotal(): Observable<Retorno> {
    let endpoint: string = this.urlBase + '/sem-exportar/total';
    let restoUrl: string = endpoint;

    this.log(
      this.constructor.name + '.' + Function.prototype.name + '()',
      this.getApiUrl() + '/' + restoUrl
    );

    return this.http
      .get(this.getApiUrl() + '/' + restoUrl, {
        headers: this.headers,
      })
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  getPontoDtUltimaExecucao(): Observable<Retorno> {
    let endpoint: string = this.urlBase + '/dt-ultima';
    let restoUrl: string = endpoint;

    this.log(
      this.constructor.name + '.' + Function.prototype.name + '()',
      this.getApiUrl() + '/' + restoUrl
    );

    return this.http
      .get(this.getApiUrl() + '/' + restoUrl, {
        headers: this.headers,
      })
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }

  getPontoExecutarExportacao(): Observable<Retorno> {
    let endpoint: string = this.urlBase + '/executar-exportar';
    let restoUrl: string = endpoint;

    this.log(
      this.constructor.name + '.' + Function.prototype.name + '()',
      this.getApiUrl() + '/' + restoUrl
    );

    return this.http
      .get(this.getApiUrl() + '/' + restoUrl, {
        headers: this.headers,
      })
      .pipe(
        timeout(this.timeout),
        delay(this.delay),
        tap(console.log),
        take(1)
      );
  }
}
